function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/rawelement
 */
import Element from './element';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import Node from './node';
/**
 * The raw element class.
 *
 * The raw elements work as data containers ("wrappers", "sandboxes") but their children are not managed or
 * even recognized by the editor. This encapsulation allows integrations to maintain custom DOM structures
 * in the editor content without, for instance, worrying about compatibility with other editor features.
 * Raw elements are a perfect tool for integration with external frameworks and data sources.
 *
 * Unlike {@link module:engine/view/uielement~UIElement UI elements}, raw elements act like real editor
 * content (similar to {@link module:engine/view/containerelement~ContainerElement} or
 * {@link module:engine/view/emptyelement~EmptyElement}), they are considered by the editor selection and
 * {@link module:widget/utils~toWidget they can work as widgets}.
 *
 * To create a new raw element, use the
 * {@link module:engine/view/downcastwriter~DowncastWriter#createRawElement `downcastWriter#createRawElement()`} method.
 *
 * @extends module:engine/view/element~Element
 */

var RawElement = /*#__PURE__*/function (_Element) {
  _inherits(RawElement, _Element);

  var _super = _createSuper(RawElement);

  /**
   * Creates a new instance of a raw element.
   *
   * Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} when the `children`
   * parameter is passed to inform that the usage of `RawElement` is incorrect (adding child nodes to `RawElement` is forbidden).
   *
   * @see module:engine/view/downcastwriter~DowncastWriter#createRawElement
   * @protected
   * @param {module:engine/view/document~Document} document The document instance to which this element belongs.
   * @param {String} name A node name.
   * @param {Object|Iterable} [attrs] The collection of attributes.
   * @param {module:engine/view/node~Node|Iterable.<module:engine/view/node~Node>} [children]
   * A list of nodes to be inserted into the created element.
   */
  function RawElement(document, name, attrs, children) {
    var _this;

    _classCallCheck(this, RawElement);

    _this = _super.call(this, document, name, attrs, children); // Override the default of the base class.

    _this._isAllowedInsideAttributeElement = true;
    /**
     * Returns `null` because filler is not needed for raw elements.
     *
     * @method #getFillerOffset
     * @returns {null} Always returns null.
     */

    _this.getFillerOffset = getFillerOffset;
    return _this;
  }
  /**
   * Checks whether this object is of the given type or name.
   *
   *		rawElement.is( 'rawElement' ); // -> true
   *		rawElement.is( 'element' ); // -> true
   *		rawElement.is( 'node' ); // -> true
   *		rawElement.is( 'view:rawElement' ); // -> true
   *		rawElement.is( 'view:element' ); // -> true
   *		rawElement.is( 'view:node' ); // -> true
   *
   *		rawElement.is( 'model:element' ); // -> false
   *		rawElement.is( 'documentFragment' ); // -> false
   *
   * Assuming that the object being checked is a raw element, you can also check its
   * {@link module:engine/view/rawelement~RawElement#name name}:
   *
   *		rawElement.is( 'img' ); // -> true if this is an img element
   *		rawElement.is( 'rawElement', 'img' ); // -> same as above
   *		text.is( 'img' ); -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * @param {String} type The type to check when the `name` parameter is present.
   * Otherwise, it acts like the `name` parameter.
   * @param {String} [name] The element name.
   * @returns {Boolean}
   */


  _createClass(RawElement, [{
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!name) {
        return type === 'rawElement' || type === 'view:rawElement' || // From super.is(). This is highly utilised method and cannot call super. See ckeditor/ckeditor5#6529.
        type === this.name || type === 'view:' + this.name || type === 'element' || type === 'view:element' || type === 'node' || type === 'view:node';
      } else {
        return name === this.name && (type === 'rawElement' || type === 'view:rawElement' || type === 'element' || type === 'view:element');
      }
    }
    /**
     * Overrides the {@link module:engine/view/element~Element#_insertChild} method.
     * Throws the `view-rawelement-cannot-add` {@link module:utils/ckeditorerror~CKEditorError CKEditorError} to prevent
     * adding any child nodes to a raw element.
     *
     * @protected
     */

  }, {
    key: "_insertChild",
    value: function _insertChild(index, nodes) {
      if (nodes && (nodes instanceof Node || Array.from(nodes).length > 0)) {
        /**
         * Cannot add children to a {@link module:engine/view/rawelement~RawElement} instance.
         *
         * @error view-rawelement-cannot-add
         */
        throw new CKEditorError('view-rawelement-cannot-add', [this, nodes]);
      }
    }
    /**
     * This allows rendering the children of a {@link module:engine/view/rawelement~RawElement} on the DOM level.
     * This method is called by the {@link module:engine/view/domconverter~DomConverter} with the raw DOM element
     * passed as an argument, leaving the number and shape of the children up to the integrator.
     *
     * This method **must be defined** for the raw element to work:
     *
     *		const myRawElement = downcastWriter.createRawElement( 'div' );
     *
     *		myRawElement.render = function( domElement ) {
     *			domElement.innerHTML = '<b>This is the raw content of myRawElement.</b>';
     *		};
     *
     * @method #render
     * @param {HTMLElement} domElement The native DOM element representing the raw view element.
     */

  }]);

  return RawElement;
}(Element); // Returns `null` because block filler is not needed for raw elements.
//
// @returns {null}


export { RawElement as default };

function getFillerOffset() {
  return null;
}